var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.077 7.41a.565.565 0 0 0 0-.816L7.952 2.656a.562.562 0 0 0-.776.813l3.108 2.97H2.312a.56.56 0 0 0-.562.563c0 .311.25.562.563.562h7.97l-3.11 2.967a.562.562 0 0 0 .776.814l4.125-3.938z"
  })));
};
export default SvgArrowRight;